export const FETCH_TABLE_DATA_BEGIN = "FETCH_TABLE_DATA_BEGIN";
export const FETCH_TABLE_DATA_SUCCESS = "FETCH_TABLE_DATA_SUCCESS";
export const FETCH_TABLE_DATA_FAILURE = "FETCH_TABLE_DATA_FAILURE";